/* global toastr:false, moment:false, ATAC:false, atac_page_settings:false, user_object:false */
(function () {
    'use strict';

    var auth = angular.module('blocks.authentication');

    auth.constant('atac_page_settings', atac_page_settings);
    auth.run(run);

    /* @ngInject */
    function run(PermRoleStore, currentUser, atac_page_settings) {
        PermRoleStore.defineRole('AUTHORIZED', function () {
            return !!atac_page_settings.security.bearerToken();
        });
        PermRoleStore.defineRole('SSO:SysAdmin', function () {
            return currentUser.isInRole('SSO:SysAdmin');
        });
        PermRoleStore.defineRole('SSO:AppAdmin', function () {
            return currentUser.isInRole('SSO:AppAdmin');
        });
        PermRoleStore.defineRole('SSO:Corp:Admin', function () {
            return currentUser.isInRole('SSO:Corp:Admin');
        });
        PermRoleStore.defineRole('SSO:Reg:Admin', function () {
            return currentUser.isInRole('SSO:Reg:Admin');
        });
        PermRoleStore.defineRole('SSO:Area:Admin', function () {
            return currentUser.isInRole('SSO:Area:Admin');
        });
        PermRoleStore.defineRole('SSO:Site:Admin', function () {
            return currentUser.isInRole('SSO:Site:Admin');
        });
        PermRoleStore.defineRole('SSO:Create_User', function () {
            return currentUser.isInRole('SSO:Create_User');
        });
        PermRoleStore.defineRole('SSO:User_Steward', function () {
            return currentUser.isInRole('SSO:User_Steward');
        });
    }
})();
